import logo from './assets/aftrprtylogo.png';
import './App.css';
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import NavBar from './components/navBar/NavBar';
import Footer from './components/footer/Footer';
import Home from './pages/Home';
import OnlineStore from './pages/OnlineStore/OnlineStore';
import { useEffect, useState } from 'react';
import useProductStore from './states/ProductStore';
import { getProducts } from './services/OnlineStore';
import ProductDetails from './pages/product/[id]';
import Cart from './pages/Cart/Cart';
import useCartStore from './states/CartStore';
import { getCart } from './services/OnlineStore';
import Checkout from './pages/Checkout/Checkout';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure/PaymentFailure';
import { LuShoppingCart } from "react-icons/lu";
import MobileNavBar from './components/mobileNav/MobileNavBar';

function App() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1100);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  useEffect(() => {
    getProducts()
      .then((data) => {
        useProductStore.getState().setProducts(data.products);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
      });
      getCart()
      .then((cart) => {
        useCartStore.getState().setCart(cart);        
      })
      .catch((error) => {
        console.error("Error fetching cart:", error);
      });
  }, []);

  const itemCount = useCartStore((state) => {
    const items = state.cart?.items ?? [];

    return items.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
  });

  const nav_tabs = [
    { name: "FORMULA", path: "/home#formula" },
    { name: "WHY IT WORKS", path: "/home#why-it-works" },
    { name: "HOW TO USE", path: "/home#how-to-use" },
    { name: "CONTACT", path: "/home#contact" },
    { name: "ORDER NOW!", 
      path: "/onlineStore", 
      scrollToTop: true,
      style: {
        backgroundColor: "color-mix(in srgb, var(--action-secondary) 15%, transparent", 
        color: "var(--secondary-200)", 
        border: "1px solid color-mix(in srgb, var(--action-secondary) 30%, transparent", 
        fontSize: "var(--font-2xs)", 
        letterSpacing: ".18em", 
        fontWeight: 800
      }
    },
    { name: "CART", path: "/cart", scrollToTop: true, badge: { style: "number", value: itemCount }, icon: <LuShoppingCart size={14}/> }
  ];

  const navLogo = {
    image: logo,
    path: "/home"
  }

  const navStyles = {
    navList: {
      border: 'var(--border-inverse-subtle', 
      backgroundColor: 'var(--page)', 
      padding: 'var(--space-4)', 
      borderRadius: 'var(--radius-pill)', 
      border: '1px solid var(--border-subtle)', 
      gap: 'var(--space-2)'
    },
    navItem: {color: 'var(--fg-muted)', fontWeight: '700', fontSize: 'var(--font-xs)'}
  }

  const navClasses = {
    navItem: "navItem",
    navItemActive: "navItemActive"
  }

  const footerLinks = [
    {
      label: "Instagram",
      href: "https://www.instagram.com/juicdpreworkout/",
    },
  ];

  const footerAttribution = {
    label: "iqventory LLC",
    href: "https://iqventoryllc.com",
  };

  return (
    <div className="App">

      { isMobile ? 
      <MobileNavBar navItems={nav_tabs} navLogo={navLogo} navClassesOverride={navClasses}/> 
      : 
      <NavBar navItems={nav_tabs} navLogo={navLogo} navStyles={navStyles} navClassesOverride={navClasses}/> 
      }
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<Home />} />
        <Route path="/onlineStore" element={<OnlineStore />} /> 
        <Route path="/products/:productId" element={<ProductDetails />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/:paymentHashID/success" element={<PaymentSuccess />} />
        <Route path="/checkout/:paymentHashID/failure" element={<PaymentFailure />} />
        <Route path="*" element={<Navigate to="/home" />} />
        
      </Routes>

      <Footer socialLinks={footerLinks} attribution={footerAttribution} />
    </div>
  );
}

export default App;
